import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoGastosService } from '../../tipo-gastos/tipo-gastos.service';
import { GastosService } from '../gastos.service';
@Component({
  selector: 'app-gastos-update',
  templateUrl: './gastos-update.component.html',
  styleUrls: ['./gastos-update.component.scss']
})
export class GastosUpdateComponent implements OnInit {
  @Input() element: any = {}
  form: FormGroup = new FormGroup({});
  select_Tgastos: Array<any> = [];
  selected!: number;
  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private loading: LoadingService,
    private alerts: AlertService,
    public formatter: FormatterService,
    public service: GastosService,
    public _service: TipoGastosService
  ) { }

  ngOnInit(): void {
    this.select()
    this.form = this.formBuilder.group({
      id: [],
      fecha: ['', Validators.required],
      monto: ['', Validators.required],
      detalle: [''],
      tipo_gasto_id: ['', Validators.required]
    });
    this.selected = this.element.tipo_gasto_id;
    this.element.fecha = this.element.fecha.substring(0, 10);
    this.form.patchValue(this.element);
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show()
      this.service.update(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        }, error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo actualizar el registro.", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  select(): void {
    this.loading.show();
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.select_Tgastos = res
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo Cargar Tipos de gastos de la empresa", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    });
  }
}
